import { createUseStyles } from 'react-jss'

const styleOverride = createUseStyles({
  root: {    
    width: '28px',
    height: '28px',
    strokeMiterlimit: '10',
    strokeWidth: '1.2',
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill:"#464646",
    stroke: 'white',
    '& svg':{
      viewBox:'0 0 28 28'
    }
    
  },
})

export default styleOverride
